import { render, staticRenderFns } from "./AddTagBox.vue?vue&type=template&id=7a02774a&scoped=true&"
import script from "./AddTagBox.vue?vue&type=script&lang=js&"
export * from "./AddTagBox.vue?vue&type=script&lang=js&"
import style0 from "./AddTagBox.vue?vue&type=style&index=0&id=7a02774a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a02774a",
  null
  
)

export default component.exports